const FINE_POINTER_HOVER_QUERY = "(hover: hover) and (pointer: fine)";

/**
 * @param {Event} event
 * @param {Element | null} root
 * @returns {boolean}
 */
export function eventOccurredInside(event, root) {
  if (!root) {
    return false;
  }
  if (typeof event.composedPath === "function") {
    const path = event.composedPath();
    if (path.length > 0) {
      return path.includes(root);
    }
  }
  const target = event.target;
  return target instanceof Node && root.contains(target);
}

/**
 * Hover-leave should not close menus on tablets or touch emulation.
 * @returns {boolean}
 */
export function canCloseDropdownOnMouseLeave() {
  if (typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(FINE_POINTER_HOVER_QUERY).matches;
}
